import { API_PATHS } from "../../config";
import { apiRequest } from "./axios";

/**
 * Fetch projects for the Projects module landing page.
 *
 * @param {Object} params - Project list filters.
 * @param {boolean} [params.activeOnly=true] - Whether to return only currently active projects.
 * @param {string|null} [params.date=null] - Optional YYYY-MM-DD active date filter.
 * @returns {Promise<Array<Object>>}
 */
export async function getProjects({ activeOnly = true, date = null } = {}) {
  const params = new URLSearchParams();
  params.append("active", activeOnly.toString());
  if (date) {
    params.append("date", date);
  }

  return apiRequest(`${API_PATHS.PROJECTS.LIST}?${params.toString()}`, null, {
    method: "GET",
  });
}

/**
 * Fetch one project by the backing JobNumber ID.
 *
 * @param {string|number} projectId - JobNumber primary key.
 * @returns {Promise<Object>}
 */
export async function getProject(projectId) {
  return apiRequest(API_PATHS.PROJECTS.DETAIL(projectId), null, {
    method: "GET",
  });
}

/**
 * Create a project (JobNumber) from the Projects add form.
 *
 * @param {Object} payload - Same field shape as patchJobNumber.
 * @returns {Promise<Object>} Created project detail row.
 */
export async function createProject(payload) {
  return apiRequest(API_PATHS.PROJECTS.LIST, payload, {
    method: "POST",
  });
}
